import type { NounForms } from '../types'

/** "1 season", "3 seasons", "0 players". */
export const countLabel = (count: number, noun: NounForms): string =>
  `${count} ${count === 1 ? noun.singular : noun.plural}`
